import { type MakeswiftPageDocument } from '../../../../client'
import { MakeswiftComponentType } from '../../../../components/builtin/constants'

export const pageDocument: MakeswiftPageDocument = {
  id: '2222-2222-2222-2222',
  site: {
    id: '1111-1111-1111-1111',
  },
  data: {
    type: MakeswiftComponentType.Root,
    key: '0000-0000-0000-0000',
    props: {},
  },
  snippets: [],
  fonts: [],
  localizedPages: [],
  locale: null,
  meta: {},
  seo: {},
}
